import styled from 'styled-components'
import { breakpoints } from '../../constants'
import Browser from '../../services/Browser'

const spacing = '0.8rem'

const cols = Array.from({ length: 12 }, (_, index) => index + 1)
const commonCols = cols.map(num => `.col-${num}`).join(',')
const firstChildCols = cols.map(num => `.col-${num}:first-child`).join(',')
const lastChildCols = cols.map(num => `.col-${num}:last-child`).join(',')

const commonColsWidth = cols
	.map(
		num => `
			.col-${num} {
				width: calc(${100 * num}% / 12 - ${spacing} * 2);
				&:first-child,
				&:last-child {
					width: calc(${100 * num}% / 12 - ${spacing});
				}
			}

		`
	)
	.join(' ')

const smallColsWidth = cols
	.map(
		num => `
			.sm-${num} {
				width: calc(${100 * num}% / 12 - ${spacing} * 2);
				&:first-child,
				&:last-child {
					width: calc(${100 * num}% / 12 - ${spacing});
				}
			}

	`
	)
	.join(' ')

export const StyledFlexContainer = styled.div`
	position: relative;
	align-items: ${({ smStretchItems }) => (smStretchItems ? 'stretch' : 'center')};
	display: flex;
	flex-direction: ${({ smRow }) => (smRow ? 'row' : 'column')};
	${({ smSpaceAround }) =>
		smSpaceAround ? 'justify-content: space-around;' : ''}
	${({ smWrap }) => (smWrap ? 'flex-wrap: wrap;' : '')}

	${commonCols} {
		display: inline-block;
		margin-top: ${({ marginTop }) => marginTop || 2.7}rem;
		width: 100%;
		& + .filler {
			display: none;
			margin-top: 0rem;
		}
	}

	.apply-coupon,
	.total-info-coupon,
	.add-button {
		align-self: flex-end;
	}

	.origin-destination-select {
		align-self: center;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			.combo-destination {
				width: 23% !important;
			}
		}
	}

	.col-3 {
		max-width: ${Browser.isInternetExplorer() ? '220px' : 'auto'};
	}

	.info-trip-bar {
		max-width: ${Browser.isInternetExplorer() ? '355px' : ''};
	}

	.right-0 {
		margin-right: 0 !important;
	}
	.left-0 {
		margin-left: 0 !important;
	}

	.loggedpassenger-container {
		display: flex;
		height: 100%;
		align-self: center;
		margin-left: 10px;
	}

	.loggedpassenger-container-false {
		display: none;
	}

	.warning-message {
		margin-left: 0px;
		margin-top: 10px;
		width: 300px;
		align-self: flex-start;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			margin-left: 10px;
		}
	}

	${smallColsWidth}

	@media screen and (max-width: ${breakpoints.MOBILE}px) {
		.loggedpassenger-container {
			align-self: flex-start;
			margin-left: 0;
			margin-top: 37px;
			order: -1;
		}
	}

	@media screen and (max-width: ${breakpoints.IPHONE_SE}px) {
		.loggedpassenger-container {
			margin-top: 60px;
			order: -1;
		}
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		align-items: ${({ alignItems }) => alignItems || 'flex-end'};
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: ${getJustifyContent};
		align-items: flex-start;

		${commonCols} {
			margin-left: ${spacing};
			margin-right: ${spacing};
			margin-top: ${({ marginTop }) =>
				marginTop === undefined ? 2.7 : marginTop}rem;
			& + .filler {
				display: initial;
			}
		}

		${firstChildCols},
		.filler:first-child {
			margin-left: 0;
		}

		${lastChildCols},
		.filler:last-child {
			margin-right: 0;
		}

		${commonColsWidth}
	}
`

export const StyledPageContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	background-color: #f3f3f3;
	align-items: center;
	padding: 20px;

	.sord-options-container {
		width: 100%;
		display: flex;
		justify-content: center;

		.sord-options-sub-container {
			display: flex;
			flex-direction: column;

			label {
				font-size: 15px;
				margin-bottom: 7px;
			}

			.sord-select-container {
				width: 250px;
			}
		}
	}
`

export const StyledImageStoreContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 40px 0px;

	> div {
		width: calc(300% / 12 - 0.8rem);
	}
`

export const StyledProductsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 24px;
	padding: 24px 0;
	justify-content: center;
	width: 100%;

	& > div {
		flex: 0 0 250px;
		width: 250px;
	}

	@media (max-width: ${breakpoints.MOBILE}px) {
		gap: 16px;
		padding: 16px 0;
	}
`

function getJustifyContent({ center, spaceBetween }) {
	if (Browser.isInternetExplorer()) return 'space-around'
	if (center) return 'center'
	if (spaceBetween) return 'space-between'
	return 'initial'
}

export default StyledFlexContainer
